import React, {useEffect} from 'react';
import './news.scss';
import {Navigation, Footer} from "../../components";
import NewsHero from "./sections/news-hero/NewsHero";
import NewsList from "./sections/news-list/NewsList";

const News = () => {
    useEffect(() => {
        window.scrollTo(0, 0);

    }, []);

    return (
        <div className={'news-page'}>
            <div className="news-page_nav">
                <Navigation/>
            </div>
            <NewsHero/>
            <NewsList/>
            <Footer/>
        </div>
    );
};

export default News;
